import React from "react";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";


const NavBg = styled.div`
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 998;
    width: 100%;
    max-width: 100vw;
    height: 250px;
    background-color: rgba(0, 0, 0, 0.25);
    visibility: hidden;
    transition: all 0.3s ease;
    opacity: 0;

`;
const ListItem2 = styled.ul`
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 999;
    right: 0;
    max-width: 100vw;
    width: 100%;
    margin-top: 2vw;
    text-align: center;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;

`;
const NavWrapper = styled.div`
    &:hover ${NavBg},
    &:hover ${ListItem2} {
        opacity: 1;
        visibility: visible;
    }
`;
const Nav = styled.nav``;
const MenuList = styled.ul`
    display: flex;
    &:hover {
        transition: all 0.3s ease;
    }
`;
const Dep1 = styled.li`
    position: relative;
    display: inline-block;
    padding: 20px 4.5vw;
    white-space: nowrap;
    vertical-align: top;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
`;
const Dep2 = styled.li`
    color: #f4f4f4;
    font-size: 17px;
    line-height: 28px;
    cursor: pointer;
    transition: all 0.3s;
    font-weight: 400;

    &:hover {
        color: #ed8e0c;
        font-weight: 700;
    }

    &:not(:first-child) {
        margin-top: 12px;
    }
`;



const Navigation = ({menu}) => {
    const navigate = useNavigate();
    const handleNavigation = (url) => {
        if (url.startsWith("http")) {
            window.open(url, "_blank"); // 새 탭에서 열기
        } else {
            navigate(url);
        }
    };

    return (
        <NavWrapper>
            <Nav>
                <MenuList>
                    {menu.map((item, index) => (
                        <Dep1 key={index} onClick={() => {navigate(item.title.url)}}>
                            {item.title.name}
                            <ListItem2>
                                {item.sub.map((subItem, index2) => (
                                    <Dep2 key={index2}  onClick={(e) => {
                                        e.stopPropagation(); // 부모 클릭 방지
                                        handleNavigation(subItem.url);
                                    }} >
                                        {subItem.name}
                                    </Dep2>
                                ))}
                            </ListItem2>
                        </Dep1>
                    ))}
                </MenuList>
            </Nav>
            <NavBg/>
        </NavWrapper>
    );
};

export default Navigation;
